import { Component, OnInit } from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {UserService} from "./user.service";
import { SnackBarService } from '../snackBar.service';
import {ActivatedRoute, Router} from "@angular/router";
import { MainNavService} from "../mainNav.service";
import {CurrentRouteService} from "../currentRoute.service";
import {ModelValidators} from '../validators/validators';
/*

Forgot your password?
Enter your Email below and we will send a message to reset your password
 */

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  myForm: UntypedFormGroup;
  hide = true;
  hide_new = true;
  is_loading = false;
  is_response = false;
  response = '';


  constructor(private fb: UntypedFormBuilder,
              private route: ActivatedRoute,
              public router: Router,
              private _userService: UserService,
              private snackbarService: SnackBarService,
              private mainnavService: MainNavService,
              private currentrouteService: CurrentRouteService) { }

  ngOnInit(): void {

    let query_parms = this.route.snapshot.queryParamMap;
    let is_user_settings = query_parms.get('is_user_settings');
    let is_account_route = query_parms.get('is_account_route');

    this.currentrouteService.announceCurrentRoute(this.router.url);
    this.mainnavService.announceMainNav({is_user_settings: is_user_settings,is_account_route: is_account_route})
    console.log(query_parms)

    this.myForm = this.fb.group({
      previous_password: ['', [Validators.required, ModelValidators.passwordControls]],
      proposed_password: ['', [Validators.required, ModelValidators.passwordControls]]
    })//end myForm
  }

  onSubmit(){
    let data = this.myForm.value;


    const userData: {
      uid: string,
      username: string,
      email: string,
      role: string,
      refresh_token: string,
      access_token: string,
      id_token: string,
      _tokenExpirationDate: string
      exp: number
    } = JSON.parse(localStorage.getItem('userData'));

    data['access_token'] = userData['access_token'];
    this.is_loading = true;
    this.is_response = false;
    this.response = ''

    this._userService.post('user/password',data).subscribe(
      data => {
        console.log(data);
        this.is_loading = false;
        this.snackbarService.announceSackBar('Password changed successfully');
        this.myForm.reset()
        this.is_response = true;
        this.response = 'Password changed successfully'
      },
      error => {
        this.is_loading = false;
        this.response = 'Incorrect password'
        console.log(error);
      }) //end postApiData
    }// end onSubmit

}
